
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import {
    renderAutoCompleteSingleSelect,
    renderTextField,
    isInteger, 
} from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { getTargetsAndProgramsData } from './actions/soapActions';
// import _ from 'lodash';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
    const errors = {};

    if (!values.goalArray || !values.goalArray.length) {
        errors.goalArray = { _error: 'At least one goal data must be selected' };
    } else {
        const goalArrayErrors = [];
        const allGoalsArray = values.goalArray || [];
        values.goalArray.forEach((goalObj, index) => {
            const restGoalsArray = allGoalsArray.filter((obj, goalIndex) => goalIndex !== index);            
            const goalErrors = {};
            if (!goalObj.skillsAcquisitionProgramId) {
                goalErrors.skillsAcquisitionProgramId = 'Please select program';
            }
            else if (goalObj.skillsAcquisitionProgramId && goalObj.skillsAcquisitionTargetId) {
                let isGroupExist = (restGoalsArray || []).find((obj) => obj.skillsAcquisitionProgramId === goalObj.skillsAcquisitionProgramId  && obj.skillsAcquisitionTargetId === goalObj.skillsAcquisitionTargetId);
                if (isGroupExist) {
                    goalErrors.skillsAcquisitionProgramId = 'Please select another program or target';
                }
            }

            if (!goalObj.skillsAcquisitionTargetId) {
                goalErrors.skillsAcquisitionTargetId = 'Please select target';
            }
            if (!goalObj.data) {
                goalErrors.data = 'Please enter data';
            }
            // if (!goalObj.comments) {
            //     goalErrors.comments = 'Please enter comments';
            // }
            goalArrayErrors[index] = goalErrors;
            return goalArrayErrors;
        });
        if (goalArrayErrors.length) {
            errors.goalArray = goalArrayErrors;
        }
    }
    return errors;
}
class AddGoalModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId,
            patientEncounterId: props.patientEncounterId,
            sessionNoteId: props.sessionNoteId,
            cbgDataCollectionId: props.cbgDataCollectionId,
        };
        this.addRow = this.addRow.bind(this);
        this.removeRow = this.removeRow.bind(this);
    }

    componentWillMount() {
        this.props.getTargetsAndProgramsData(this.props.patientId);
    }

    componentWillReceiveProps() {

        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    onSubmit(formData) {
        formData.goalArray = (formData.goalArray || []).map((goalObj) => {
            let goalData = this.props.masterPatientGoals.find(obj => obj.id === goalObj.skillsAcquisitionTargetId);
            return {
                ...goalObj,               
                goalName: goalData && goalData.value,
                patientEncounterId: this.state.patientEncounterId,
                sessionNoteId: this.state.sessionNoteId,
                cbgDataCollectionId: this.state.cbgDataCollectionId,
                isDeleted: false,
                // skillsAcquisitionProgramId: null,
                // skillsAcquisitionTargetId: null,
            }
        });

        this.props.addGoalData(formData);
        this.setState({ open: false });
        this.props.closeDialog();
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }

    addRow = () => { };
    removeRow = (i) => { };

    renderMembers = ({ fields }) => {
        this.removeRow = (i, e) => {
            fields.remove(i);
        };

        this.addRow = (e) => {
            fields.push({});
        };

        return (
            <div>
                {fields.map((goalObj, index) => {
                    // let restSelectors = (this.props.selectorGoalArray || []).filter((obj, pIndex) => pIndex !== index);
                    // let dropdownFilteredPatientGoals = _.differenceWith(this.props.masterPatientGoals, restSelectors, function(o1, o2) {
                    //     return o2['skillsAcquisitionTargetId'] == o1['id'];
                    // });
                    let currentSelectorProgramId = this.props.selectorGoalArray && this.props.selectorGoalArray[index].skillsAcquisitionProgramId;
                    let dropdownFilteredPatientGoals = (this.props.masterPatientGoals || []).filter(obj => obj.programId === currentSelectorProgramId);
                    return (<div className="row pdr-40 parent_div" key={index}>
                        <div className="col-sm-6 mt-35 require">
                            <Field
                                name={`${goalObj}.skillsAcquisitionProgramId`}
                                label="Program Name"
                                options={this.props.masterPatientPrograms}
                                handleNewRequest={(input, selected) => input.onChange(selected.value)}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>
                        <div className="col-sm-6 mt-35 require">
                            <Field
                                name={`${goalObj}.skillsAcquisitionTargetId`}
                                label="Target Name"
                                options={dropdownFilteredPatientGoals}
                                handleNewRequest={(input, selected) => input.onChange(selected.value)}
                                component={renderAutoCompleteSingleSelect}
                            />
                        </div>
                        <div className="col-sm-6 require">
                            <Field
                                name={`${goalObj}.data`}
                                type="text"
                                maxLength="5"
                                label="Data"
                                component={renderTextField}
                                normalize={isInteger}
                            />
                        </div>
                        <div className="col-sm-6">
                            <Field
                                name={`${goalObj}.comments`}
                                type="text"
                                maxLength="50"
                                label="Comment"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            {fields.length === index + 1 ?
                                <div>
                                    {fields.length > 1 ?
                                        <button className="removeitem"
                                            onClick={this.removeRow.bind(this, index)}
                                            title="Remove Goal data"
                                            type="button">
                                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                        </button>
                                        : ''}
                                    <button className="additem" title="Add Goal data" onClick={(e) => this.addRow()} type="button">
                                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                    </button>
                                </div>
                                :
                                <div>
                                    <button className="removeitem"
                                        onClick={this.removeRow.bind(this, index)}
                                        title="Remove Goal data"
                                        type="button">
                                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                    </button>
                                </div>
                            }
                        </div>

                    </div>);
                }
                )
                }
            </div>
        );
    };

    render() {
        const { handleSubmit } = this.props;
        const actions = [
            <CommonButton className="mr-15 grey_btn" label="Cancel" onTouchTap={this.handleClose} />,
            <CommonButton type="submit" primary={true} label="Save" onTouchTap={handleSubmit(this.onSubmit.bind(this))} />,
        ];
        return (
            <div>
                {this.state.open ?
                    <Dialog className="custom_modal"
                        title="Soap Data Entry"
                        modal={false}
                        actions={actions}
                        open={this.state.open}
                        autoScrollBodyContent={true}
                    >
                        {this.renderLoading()}
                        <div className="row">
                            <div className="col-sm-12">
                                <form className="readmin-form custom_form" noValidate>
                                   
                                    <FieldArray name="goalArray" component={this.renderMembers} />
                                </form>
                            </div>
                        </div>
                    </Dialog> : null}
            </div>
        );
    };
}
const selector = formValueSelector('AddGoalModalForm');
AddGoalModal = reduxForm({
    form: 'AddGoalModalForm',
    validate,
    enableReinitialize: true, // this is needed!!
})(AddGoalModal);

function mapStateToProps(state) {
    let masterPatientGoals = [], masterPatientPrograms= [],
    initialData = {
        goalArray: [{}],
    };
    if (state.soap.targetsAndProgramsData) {
        masterPatientGoals = state.soap.targetsAndProgramsData.data.Targets || [];
        masterPatientPrograms = state.soap.targetsAndProgramsData.data.Programs || [];
    }
    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientGoals: masterPatientGoals,
        masterPatientPrograms: masterPatientPrograms,
        initialValues: initialData,
        selectorGoalArray: selector(state, "goalArray")
    };
};

export default connect(mapStateToProps, { getTargetsAndProgramsData })(AddGoalModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_CBG/addGoalModal.js